import { Keyboard } from 'lucide-react'

import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { canUseKeyboardShortcuts, NOTION_SHORTCUT_SECTIONS } from '@/lib/notion-shortcuts'
import { isMac, parseShortcutKeys } from '@/lib/tiptap-utils'

/** メモ編集画面のショートカット一覧。タッチ端末では出さない */
export const ShortcutHelp = () => {
  if (!canUseKeyboardShortcuts()) return null

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label="ショートカット一覧"
          title="ショートカット一覧"
          className="flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-md text-muted-foreground hover:bg-accent hover:text-foreground"
        >
          <Keyboard className="size-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="max-h-[70dvh] w-80 overflow-y-auto p-3">
        <div className="space-y-3">
          {NOTION_SHORTCUT_SECTIONS.map((section) => (
            <section key={section.title}>
              <h3 className="mb-1 text-xs font-semibold text-muted-foreground">{section.title}</h3>
              <ul className="space-y-0.5">
                {section.items.map((item) => (
                  <li key={item.label} className="flex items-center justify-between gap-2 text-sm">
                    <span>{item.label}</span>
                    <kbd className="rounded border bg-muted px-1.5 py-0.5 font-sans text-xs text-muted-foreground">
                      {parseShortcutKeys({ shortcutKeys: item.keys }).join(isMac() ? '' : '+')}
                    </kbd>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  )
}
